import { UserApiClient } from '@fourthwall/services/dist/UserApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useUserConnectionsQuery = createQueryHook(UserApiClient.getUserConnections, {
  queryKey: ['userConnections'],
})
